// Import configuration presets for different organizations or environments
import defaultConfig from "./default.config";              // Fallback/default settings
import orgA from "./orgA.config";                          // Specific config for Organization A
import smartSandboxConfig from "./smartSandbox.config";    // Config for SMART Sandbox environment

/**
 * Loads an organization-specific configuration based on the issuer (iss) URL.
 * @param {string} iss - The issuer URL typically provided by the SMART launch context
 * @returns {object} - A matching config object, or the default if no match
 */
export function loadOrgConfig(iss) {
  console.log("🔧 loadOrgConfig invoked with ISS:", iss);

  // If no issuer is provided, return default configuration
  if (!iss) {
    console.warn("⚠️ No ISS provided — falling back to default config.");
    return defaultConfig;
  }

  // Extract the host portion of the issuer URL (e.g., "launch.smarthealthit.org")
  let host;
  try {
    host = new URL(iss).host;
    console.log("🌐 Parsed host from ISS:", host);
  } catch (error) {
    console.error("❌ Failed to parse host from ISS:", iss, "Error:", error);
    return defaultConfig;
  }

  // Match known hosts to specific configuration files
  if (host.includes("orga.fhir.example")) {
    console.log("🏥 Matched host to orgA config.");
    return orgA;
  }

  if (host.includes("launch.smarthealthit.org")) {
    console.log("🧪 Matched host to SMART Sandbox config.");
    return smartSandboxConfig;
  }

  // If no matching host found, return default configuration
  console.warn("🔍 Host did not match known configs — using default.");
  return defaultConfig;
}